import { FullBleedList } from "common/FullBleedList";
import { featureTypes } from "common/MapV2/featureTypes";
import { Distance, Duration, Elevation } from "common/units";
import { TrackLocation } from "data/records";
import { commonNouns, Msg } from "lib/localization";
import React, { useEffect, useState } from "react";
import styles from "./TripLaps.scss";

const onIdle = window.requestIdleCallback || window.requestAnimationFrame;

const getLapMetrics = (lapPoints) =>
  new Promise((resolve, reject) => {
    onIdle(() => {
      const tpsResult = window.rwgps.TrackPoint.fromJSON(lapPoints);
      const points = tpsResult.trackPoints;
      const data = new window.rwgps.Data(points);
      const mc = new window.rwgps.MetricsCalculator(data, false);
      const metrics = mc.calculate();
      resolve(metrics);
    });
  });

const TripLap = ({ rawPoints, lap, i, onFeatureSelected, onFeatureHovered }) => {
  const [lapMetrics, setLapMetrics] = useState();

  useEffect(() => {
    const lapPoints = rawPoints.slice(lap.first_i, lap.last_i + 1);
    getLapMetrics(lapPoints).then((metrics) => setLapMetrics(metrics));
  }, []);

  const feature = {
    type: featureTypes.LAP,
    firstI: lap.first_i,
    data: {
      highlightSlice: [TrackLocation({ left: lap.first_i, pct: 0 }), TrackLocation({ left: lap.last_i, pct: 0 })],
      lapNumber: i + 1,
    },
  };

  return (
    <>
      {lapMetrics && (
        <li
          className={styles.TripLap}
          onMouseOver={() => onFeatureHovered(feature)}
          onMouseOut={() => onFeatureHovered(null)}
          onClick={() => onFeatureSelected(feature)}
        >
          <div>
            #{i + 1} – <Duration biggestUnits valueOnly value={lapMetrics.movingTime} />
          </div>
          <div className={styles.metrics}>
            <span className={styles.eleGain}>
              +<Elevation short value={lapMetrics.ele_gain} />
            </span>
            <span className={styles.distance}>
              <Distance short value={lapMetrics.distance} bigUnits />
            </span>
          </div>
        </li>
      )}
    </>
  );
};

const findLaps = (rawPoints) => {
  let lapsList = [];
  let prev_i = 0;
  rawPoints.forEach((point, i) => {
    if (point.lap) {
      lapsList.push({ first_i: prev_i, last_i: i });
      prev_i = i;
    }
  });
  // if we found laps, add the last lap
  if (lapsList.length > 0) {
    lapsList.push({ first_i: prev_i, last_i: rawPoints.length - 1 });
  }

  return lapsList;
};

export const TripLaps = ({ trip, onFeatureHovered, onFeatureSelected }) => {
  const [laps, setLaps] = useState();

  useEffect(() => {
    setLaps(findLaps(trip.rawPoints));
  }, []);

  return (
    <>
      {laps && laps.length > 0 && (
        <div className={styles.TripLaps}>
          <h2>
            <Msg capitalized m={commonNouns.laps} values={{ count: 0 }} />
          </h2>
          <FullBleedList>
            {laps.map((lap, i) => (
              <TripLap
                key={i}
                lap={lap}
                i={i}
                onFeatureHovered={onFeatureHovered}
                onFeatureSelected={onFeatureSelected}
                rawPoints={trip.rawPoints}
              />
            ))}
          </FullBleedList>
        </div>
      )}
    </>
  );
};
